// extracted by mini-css-extract-plugin
module.exports = {"main":"General_main__TfZ5G"};